import { PulseBaseProvider } from '../../base-classes';

const _hourlyForecastUri = '/api/for/hourly/v6';
const _hourlyForecastCacheKey = 'hourlyForecast';


export class HourlyForecastProviderV6 extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_hourlyForecastCacheKey] = this.hourlyForecastSyncer.bind(this);
    }

    async hourlyForecastSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            offset: syncParams.offset,
            length: syncParams.length,
            temperatureUnit: syncParams.temperatureUnit, 
            pressureUnit: syncParams.pressureUnit, 
            speedUnit: syncParams.speedUnit,
            precipitationUnit: syncParams.precipitationUnit,
            precipitationRateUnit: syncParams.precipitationRateUnit,
            roundingProfile: syncParams.roundingProfile,
            verbose: syncParams.verbose
        };


        const responseValidator = response => {
            return !!response;
        };

        const apiPath = `${_hourlyForecastUri}/locationType=latitudelongitude/location=${syncParams.location}`;

        return await super.syncData(syncParams.key, id, queryParams, apiPath, resolve, reject, responseValidator, syncParams.pulseApi, null, null, true, syncParams.cacheDuration);
    }

    async getHourlyForecast(location, locationtype, offset, length, stdParameters, verbose, refresh = false, temperatureUnit, pressureUnit, speedUnit, precipitationUnit, precipitationRateUnit, roundingProfile, cacheDuration) {
        const syncParams = {
            location,
            locationtype,
            offset: offset && offset >= 0 ? offset : 0,
            length: length && length >= 0 ? length : 0,
            verbose: !!verbose,
            refresh,
            temperatureUnit,
            pressureUnit,
            speedUnit,
            precipitationUnit,
            precipitationRateUnit,
            roundingProfile
        };
        const id = JSON.stringify(syncParams);

        syncParams.cacheDuration = cacheDuration;

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_hourlyForecastCacheKey, id);
        }
        return await super.loadFromStorage(_hourlyForecastCacheKey, id, syncParams);
    }
}
